<template>
  <v-card
    elevation="2"
    min-height="fit-content"
    height="100%"
    @mouseover="isHovered = true"
    @mouseleave="isHovered = false"
    @click="selectProduct"
    class="d-flex flex-column justify-space-between"
  >
    <div class="pb-4">
      <v-card-title
        v-if="product.isRecommendedDiscount"
        class="secondary justify-center py-0 text-overline"
      >
        <v-spacer></v-spacer>Recommended
        <v-spacer></v-spacer>
        <v-icon small color="black"> mdi-thumb-up </v-icon>
      </v-card-title>
      <v-card-title
        v-else-if="product.featured === true"
        class="secondary justify-center py-0 text-overline"
      >
        <v-spacer></v-spacer>{{ $i18n.t("headings.featured") }}
        <v-spacer></v-spacer>
        <v-icon small v-if="product.featured === true" color="black">
          mdi-star
        </v-icon>
      </v-card-title>
    </div>
    <div style="min-height: 100px; max-height: 100px">
      <v-img
        :src="imgSrc"
        height="100"
        contain
        :loading="!product.thumbnailImages.length"
      >
        <template v-slot:placeholder>
          <v-row class="fill-height ma-0 align-center justify-center">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </v-row>
        </template>
      </v-img>
    </div>
    <v-row no-gutters class="justify-end align-end flex-nowrap">
      <v-card-title
        ><div
          style="
            font-size: 1.25rem;
            line-height: 1.4rem;
            text-decoration: none !important;
            word-break: break-word;
            overflow: hidden;
            max-height: 68px;
          "
        >
          {{ product.title }}
        </div>
      </v-card-title>
      <v-spacer></v-spacer>
      <div
        class="d-flex flex-column-reverse pa-3 align-end"
        style="height: 100%"
         v-if="
          productSubscriptions?.some(
            (subscription) => subscription.productId === product.id,
          ) ||
          syncedBoughtProducts?.some((id) => id === product.id) ||
          hasSchoolAccess(product.id) ||
          pendingProducts?.some((id) => id === product.id)
        "
      >
        <v-icon
          v-if="pendingProducts.some((id) => id === product.id)"
          color="primary"
        >
          mdi-cart-check
        </v-icon>
        <v-icon
          v-if="
            productSubscriptions?.some(
              (subscription) => subscription.productId === product.id,
            )
          "
          color="primary"
        >
          mdi-book-check
        </v-icon>
        <v-icon
          v-if="syncedBoughtProducts?.some((id) => id === product.id)"
          color="primary"
        >
          mdi-cash-check
        </v-icon>
        <v-icon v-if="showSchoolAccessIcon" color="primary">
          mdi-school
        </v-icon>
      </div>
    </v-row>
    <v-card-actions class="justify-space-between primary--text pt-0">
      <template
        v-if="
          !(
            productSubscriptions?.some(
              (subscription) => subscription.productId === product.id,
            ) ||
            syncedBoughtProducts?.some((id) => id === product.id) ||
            hasSchoolAccess(product.id) ||
            pendingProducts.some((id) => id === product.id)
          )
        "
      >
        <v-btn icon @click.stop="addToCart">
          <v-icon color="primary">mdi-plus</v-icon>
        </v-btn>
      </template>
      <v-spacer v-else />
      <div
        class="font-weight-medium"
        v-html="
          productPrice(
            product.price,
            product.effectiveDiscount || product.discountPercentage,
          )
        "
      ></div>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import subjectAccessMixin from "@/mixins/subjectAccessMixin.js";

export default {
  name: "ProductCard",
  mixins: [subjectAccessMixin],
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    // thumbnailImages: [],
    isHovered: false,
  }),
  computed: {
    ...mapState({
      productSubscriptions: (state) =>
        state.syncedTeacherProfileModel?.productSubscriptions,
      syncedBoughtProducts: (state) => state.syncedBoughtProducts,
      // syncedPendingProducts: (state) => state.syncedPendingProducts,
    }),

    ...mapGetters(["pendingProducts"]),

    // Only when they don't already own it outright - otherwise the card would
    // stack two ownership icons.
    showSchoolAccessIcon() {
      if (!this.hasSchoolAccess(this.product.id)) return false;
      return !this.syncedBoughtProducts?.some((id) => id === this.product.id);
    },

    imgSrc() {
      const multipleThumbs = this.product.thumbnailImages.length > 1;

      if (!multipleThumbs) {
        return this.product.thumbnailImages[0];
      } else if (this.isHovered && multipleThumbs) {
        return this.product.thumbnailImages[1];
      } else return this.product.thumbnailImages[0];
    },
  },
  methods: {
    // async loadThumbnail(entries) {
    //   if (entries[0].isIntersecting && this.thumbnailImages.length === 0 && this.product.thumbnails?.length > 0) {
    //     try {
    //       const maxThumbnails = Math.min(this.product.thumbnails.length, 2);
    //       for (let i = 0; i < maxThumbnails; i++) {
    //         const thumbnailImgSrc = await Storage.get(this.product.thumbnails[i], {
    //           level: "public",
    //         });
    //         this.thumbnailImages.push(thumbnailImgSrc);
    //       }
    //     } catch (error) {
    //       console.log("Error loading thumbnail:", error);
    //     }
    //   }
    // },
    selectProduct() {
      this.$emit("select", this.product.id);
    },
    addToCart() {
      this.$emit("add-to-cart", this.product.id);
    },
    productPrice(price, discountPercentage) {
      // console.log("price:", price, "discountPercentage:", discountPercentage);
      return price && discountPercentage
        ? `<del>R${(price || 0).toFixed(2)}</del> R` +
            ((price || 0) - (price || 0) * (discountPercentage / 100)).toFixed(2)
        : (price || 0).toFixed(2)
        ? "R" + (price || 0).toFixed(2)
        : "FREE";
    },
  },
};
</script>
